import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import type { PsoLogsState, Scenario, EventStatus, ScenarioFilter, GetFileComparisonResponse, GetWarningsTypesResponse } from './types';

const initialState: PsoLogsState = {
    showScenariosSpinner: false,
    showDownloadSpinner: false,
    scenarios: {
        selected: [],
        data: [],
        filter: {
            pageNumber: 1,
            pageSize: 10,
            searchString: "",
            taskId: null
        },
        total: 0,
    },
    warnings: {
        items: [],
    },
    logLevels: {
        selected: [],
        items: {}
    },
    compareRules: {
        selected: [],
        items: {}
    },
    eventStatus: null,
};

export const psoLogsSlice = createSlice({
    name: 'psoLogs',
    initialState,
    reducers: {
        setScenarios(state, action: PayloadAction<{ data: Scenario[]; total: number; filter: ScenarioFilter }>) {
            state.scenarios = { ...state.scenarios, ...action.payload };
        },
        selectScenarios(state, action: PayloadAction<number[]>) {
            state.scenarios.selected = action.payload;
        },
        setWarnings(state, action: PayloadAction<GetFileComparisonResponse | GetWarningsTypesResponse>) {
            state.warnings = action.payload.warnings;
            state.logLevels = action.payload.logLevels;
            state.compareRules = 'compareRules' in action.payload ? action.payload.compareRules : initialState.compareRules;
        },

        toggleDownloadSpinner(state) {
            state.showDownloadSpinner = !state.showDownloadSpinner;
        },
        toggleScenariosSpinner(state) {
            state.showScenariosSpinner = !state.showScenariosSpinner;
        },

        selectLogLevels(state, action: PayloadAction<string[]>) {
            state.logLevels.selected = action.payload;
        },
        selectCompareRules(state, action: PayloadAction<string[]>) {
            state.compareRules.selected = action.payload;
        },

        resetWarnings(state) {
            state.warnings = initialState.warnings;
            state.logLevels = initialState.logLevels;
            state.compareRules = initialState.compareRules;
        },

        setEventStatus(state, action: PayloadAction<EventStatus>) {
            state.eventStatus = action.payload;
        },

        reset() {
            return { ...initialState };
        },
    },
});

export const actions = psoLogsSlice.actions;
export default psoLogsSlice.reducer;